let analyticsItem;
let itemValue;

export const removeExtraCharacters = (inputString: string): string => {
  const regex = /(H\d+)/;
  const match = regex.exec(inputString);
  if (match) {
    const result = inputString.slice(0, match.index + match[0].length);
    return result;
  }
  return inputString;
};

export const registerAnalyticsViewListEvent = (productsFromApi, filters) => {
  const googleAnalyticsObject = {
    event: 'view_item_list',
    ecommerce: {
      item_list_name: `Overview - HealthCare`,
      comparison_id: productsFromApi[0].commonTechnical[0].transactionReference,
      items: productsFromApi.map((elem, index) => {
        return generateAnalyticsItem(elem, index, filters);
      }),
    },
  };

  window?.dataLayer?.push({ ecommerce: null });
  window?.dataLayer?.push(googleAnalyticsObject);
  return googleAnalyticsObject.ecommerce.items;
};

export const registerAnalyticsViewItemEvent = (product) => {
  analyticsItem = product.analyticsData;
  itemValue = product?.expectedAcquisitionCommissionPartnerAmount;

  const googleAnalyticsObject = {
    event: 'view_item',
    ecommerce: {
      currency: 'EUR',
      coupon: '',
      items: [analyticsItem],
    },
  };
  window?.dataLayer?.push({ ecommerce: null });
  window?.dataLayer?.push(googleAnalyticsObject);
};

export const registerAnalyticsAddToCartEvent = (product) => {
  analyticsItem = product.analyticsData;
  itemValue = product?.expectedAcquisitionCommissionPartnerAmount;

  const googleAnalyticsObject = {
    event: 'add_to_cart',
    ecommerce: {
      currency: 'EUR',
      value: getItemValue(),
      coupon: '',
      items: [analyticsItem],
    },
  };
  window?.dataLayer?.push({ ecommerce: null });
  window?.dataLayer?.push(googleAnalyticsObject);
};

export const registerAnalyticsRemoveFromCartEvent = (product) => {
  analyticsItem = product.analyticsData;
  itemValue = product?.expectedAcquisitionCommissionPartnerAmount;

  const googleAnalyticsObject = {
    event: 'remove_from_cart',
    ecommerce: {
      currency: 'EUR',
      value: getItemValue(),
      coupon: '',
      items: [analyticsItem],
    },
  };
  window?.dataLayer?.push({ ecommerce: null });
  window?.dataLayer?.push(googleAnalyticsObject);
};

export const registerAnalyticsApplyPageEvent = (index) => {
  const applyPageEvents = [
    {
      event: 'begin_checkout',
      ecommerce: {
        currency: 'EUR',
        value: getItemValue(),
        coupon: '',
        items: [analyticsItem],
      },
    },
    {
      event: 'enter_final_details',
      ecommerce: {
        currency: 'EUR',
        value: getItemValue(),
        coupon: '',
        items: [analyticsItem],
      },
    },
    {
      event: 'add_payment_information',
      ecommerce: {
        currency: 'EUR',
        value: getItemValue(),
        coupon: '',
        items: [analyticsItem],
      },
    },
  ];

  if (Object.keys(applyPageEvents[index]).length > 0) {
    window?.dataLayer?.push({ ecommerce: null });
    window?.dataLayer?.push(applyPageEvents[index]);
  }
};

const generateAnalyticsItem = (data, index, filters) => {
  const affiliation =
    data.affiliateUrl === ''
      ? 'Direct'
      : data.affiliateUrl.includes('awin1')
      ? 'Awin'
      : 'Daisycon';

  const price = parseFloat(
    (filters.showPriceMode[0] === 'month'
      ? data.priceInfo.initial
      : data.priceInfo.initial / 12
    ).toFixed(2)
  );

  return {
    item_id: removeExtraCharacters(data.id),
    item_name: data.productName,
    item_list_name: 'Overview - HealthCare',
    affiliation,
    coupon: '',
    currency: 'EUR',
    index: index + 1,
    item_brand: data.provider.name,
    item_category: 'HealthCare',
    item_category2: generateCoverageMappings(filters).join(', '),
    item_category3: data.partyPolicyHolders[0].partyPartners.length + 1,
    item_category4: data.partyPolicyHolders[0].partyChildren.length,
    item_category5: data.bigProductFeature.value.month,
    price,
  };
};

const generateCoverageMappings = (filters) => {
  let coveragesMapping: string[] = [];
  let filtersCopy = { ...filters };

  delete filtersCopy['showPriceMode'];
  delete filtersCopy['rivm'];
  delete filtersCopy['freeChoiceOfCaregiver'];
  delete filtersCopy['providerName'];
  delete filtersCopy['strictestLevelNewInsured'];

  Object.keys(filtersCopy).map((key) => {
    if (filtersCopy[key][0] !== '-1') {
      coveragesMapping.push(key);
    }
  });

  return coveragesMapping;
};

const getItemValue = () => {
  return itemValue;
};
